import React from 'react';
import PropTypes from 'prop-types';
import useForm from '@afosto/utils-react/validation/useForm';
import useIntl from '@afosto/utils-react/intl/useIntl';
import AsyncSelect from '@afosto/app-components-react/AsyncSelect';
import Form from '@afosto/app-components-react/Form';
import validationSchema from './validations';
import translations from './translations';

const CredentialIntegrationForm = ({ appCode, credentials, onCancel, onSubmit }) => {
  const intl = useIntl();
  const form = useForm({
    validationSchema,
    defaultValues: {
      integrationId: credentials?.integration_id ?? null,
    },
    onCancel,
    onSubmit,
  });

  return (
    <Form form={form}>
      <AsyncSelect
        name="integrationId"
        label={intl.formatMessage(translations.fields.integration)}
        url={`/int/apps/integrations?app_code=${appCode}`}
        suggestionLabelKey="name"
        suggestionValueKey="id"
        clearable
      />
    </Form>
  );
};

CredentialIntegrationForm.propTypes = {
  appCode: PropTypes.string,
  credentials: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

CredentialIntegrationForm.defaultProps = {
  appCode: '',
  credentials: undefined,
  onCancel: undefined,
  onSubmit: undefined,
};

export default CredentialIntegrationForm;
